
// public urls
const HOME = '/home'
const GIFTING = '/'
const SSL_COMMERZ_FINISH_PAYMENT = '/sslcommerz-finish-payment'

export const giftingRoutes = {
    HOME,
    GIFTING,
    SSL_COMMERZ_FINISH_PAYMENT
}

export const giftingRoutesUrlArray = Object.values(giftingRoutes)